module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/6_d4126b540fb3341ea9f1a099a6cccdc4.jpg";